import { Big } from 'big.js'
import getUserLocale from 'get-user-locale'

export const formatNumbers = (
    number: number | string,
    decimals?: number,
    exactDecimals?: boolean,
) => {
    const userLocale = getUserLocale() || 'en-GB'
    let numberFormat

    if (decimals) {
        number = parseFloat(number.toString()).toFixed(decimals)
    }

    const formatOptions: Intl.NumberFormatOptions = {
        maximumFractionDigits: decimals ?? 3,
    }
    if (exactDecimals && decimals !== undefined) {
        formatOptions.minimumFractionDigits = decimals
    }

    try {
        numberFormat = new Intl.NumberFormat(userLocale, formatOptions)
    } catch (e: any) {
        // ^ No type safety in this block, we can in principle receive anything and assume things.

        console.warn(
            `${e.name} was caught while constructing Intl.NumberFormat.
                      Retrying with omitted currencyDisplay: 'narrowSymbol' (known not to be supported on some Safari versions...`,
        )
        // Fallback config omitting currencyDisplay: 'narrowSymbol',
        // Mainly needed for Safari 10-14
        // Details https://caniuse.com/mdn-javascript_builtins_intl_numberformat_numberformat_currencydisplay
        numberFormat = new Intl.NumberFormat(userLocale, formatOptions)
    }

    try {
        return numberFormat.format(Big(number).toNumber())
    } catch (error) {
        console.error('Error formatting number:', error)
    }

    return number
}
